"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AClientTransport = exports.AServerTransport = exports.ATransport = exports.TransportEventWithPayload = exports.TransportEvent = exports.ReceivedTaggedData = exports.ReceivedData = exports.TaggedTransportMessage = exports.TransportMessage = exports.VolatileTransportMetadata = exports.VolatileTransportMetadataFrame = exports.TransportMetadata = exports.TransportMetadataFrame = void 0;
const uuid_1 = require("uuid");
class TransportMetadataFrame {
    constructor(id, data) {
        this.id = id;
        this.data = data;
    }
    static fromMetadataFrame(frame) {
        return new this(frame.id, frame.data);
    }
}
exports.TransportMetadataFrame = TransportMetadataFrame;
class TransportMetadata {
    constructor(frames) {
        this.frames = frames || [];
    }
    static fromMetadata(metadata) {
        return new this(metadata.frames.map(f => TransportMetadataFrame.fromMetadataFrame(f)));
    }
    has(id) {
        return this.frames.some(f => f.id === id);
    }
    find(id) {
        const frame = this.frames.find(f => f.id === id);
        if (frame)
            return frame.data;
    }
    get(id) {
        const frame = this.frames.find(f => f.id === id);
        if (!frame)
            throw new Error(`Frame ${id} not defined`);
        return frame.data;
    }
}
exports.TransportMetadata = TransportMetadata;
class VolatileTransportMetadataFrame {
    constructor(id, data) {
        this.id = id;
        this.data = data;
    }
    static fromMetadataFrame(frame) {
        return new this(frame.id, frame.data);
    }
}
exports.VolatileTransportMetadataFrame = VolatileTransportMetadataFrame;
class VolatileTransportMetadata {
    constructor(frames) {
        this.frames = frames || [];
    }
    static fromMetadata(metadata) {
        return new this(metadata.frames.map(f => VolatileTransportMetadataFrame.fromMetadataFrame(f)));
    }
    has(id) {
        return this.frames.some(f => f.id === id);
    }
    find(id) {
        const frame = this.frames.find(f => f.id === id);
        if (frame)
            return frame.data;
    }
    get(id) {
        const frame = this.frames.find(f => f.id === id);
        if (!frame)
            throw new Error(`Frame ${id} not defined`);
        return frame.data;
    }
    add(id, data) {
        this.frames.push(new VolatileTransportMetadataFrame(id, data));
    }
    addOrSet(id, data) {
        const frame = this.frames.find(f => f.id === id);
        if (frame) {
            frame.data = data;
        }
        else {
            this.frames.push(new VolatileTransportMetadataFrame(id, data));
        }
    }
    pluck(id) {
        const idx = this.frames.findIndex(f => f.id === id);
        if (idx >= 0)
            throw new Error(`Frame ${id} not defined`);
        const [frame] = this.frames.splice(idx, 1);
        return frame.data;
    }
}
exports.VolatileTransportMetadata = VolatileTransportMetadata;
class TransportMessage {
    constructor(payload, metadata) {
        this.payload = payload;
        this.metadata = metadata || new VolatileTransportMetadata();
    }
    static fromMessage(message) {
        return new this(message.payload, VolatileTransportMetadata.fromMetadata(message.metadata));
    }
}
exports.TransportMessage = TransportMessage;
class TaggedTransportMessage {
    constructor(id, message) {
        this.id = id;
        this.message = message;
    }
}
exports.TaggedTransportMessage = TaggedTransportMessage;
class ReceivedData {
    constructor(data, metadata) {
        this.data = data;
        if (metadata)
            this.metadata = { ...metadata };
        else
            this.metadata = {};
    }
}
exports.ReceivedData = ReceivedData;
class ReceivedTaggedData {
    constructor(tag, data, metadata) {
        this.tag = tag;
        this.data = data;
        if (metadata)
            this.metadata = { ...metadata };
        else
            this.metadata = {};
    }
}
exports.ReceivedTaggedData = ReceivedTaggedData;
class TransportEvent {
    constructor() {
        this.handlers = [];
    }
    on(handler) {
        this.handlers.push(handler);
    }
    off(handler) {
        const index = this.handlers.indexOf(handler);
        if (index >= 0)
            this.handlers.splice(index, 1);
    }
    emit() {
        for (const handler of this.handlers)
            handler();
    }
}
exports.TransportEvent = TransportEvent;
class TransportEventWithPayload {
    constructor() {
        this.handlers = [];
    }
    on(handler) {
        this.handlers.push(handler);
    }
    off(handler) {
        const index = this.handlers.indexOf(handler);
        if (index >= 0)
            this.handlers.splice(index, 1);
    }
    emit(data) {
        for (const handler of this.handlers)
            handler(data);
    }
}
exports.TransportEventWithPayload = TransportEventWithPayload;
class ATransport {
    constructor(identity) {
        this.messageReceivedEvent = new TransportEventWithPayload();
        this.messageSentEvent = new TransportEventWithPayload();
        this.identity = identity || uuid_1.v4().replace(/-/g, '');
    }
    onMessageReceived(handler) {
        this.messageReceivedEvent.on(handler);
    }
    onMessageSent(handler) {
        this.messageSentEvent.on(handler);
    }
}
exports.ATransport = ATransport;
class AServerTransport extends ATransport {
}
exports.AServerTransport = AServerTransport;
class AClientTransport extends ATransport {
}
exports.AClientTransport = AClientTransport;
